import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import TextTableCell from 'components/common/table/TextTableCell';
import FlexBox from 'components/common/FlexBox';

const DocumentClauseItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/documentClause/${data.clauseId}`);
  }, [historyContext, data]);

  return (
    <TableRow>
      <TableCell>{data.orderNo}</TableCell>
      <TextTableCell content={data.clauseCode} />
      <TextTableCell content={data.clauseText} />
      <TextTableCell content={data.formula} />
      <TextTableCell content={data.parentClauseId == null ? '' : data.parentClauseText} />
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton size='small' type='edit' variant='text' color='primary' title={t('Edit')} onClick={handleEdit} />
          <IconButton
            size='small'
            type='delete'
            variant='text'
            color='primary'
            title={t('Delete')}
            onClick={() => onDelete(data.clauseId)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

DocumentClauseItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default DocumentClauseItem;
